var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bc0fbee793c5dd4765382ab0b9259741f5a7f2bf"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["fe-connect@unmind"]={id:"bc0fbee793c5dd4765382ab0b9259741f5a7f2bf"};
      